import { render, staticRenderFns } from "./AdminPanelEGiftsPackageSellingHistory.vue?vue&type=template&id=27d6b504&"
import script from "./AdminPanelEGiftsPackageSellingHistory.vue?vue&type=script&lang=js&"
export * from "./AdminPanelEGiftsPackageSellingHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports